export default type => {
  return {
    props: {
      value: null
    },
    computed: {
      current() {
        return this.value || this[type][0].name;
      }
    },
    methods: {
      toggle(name) {
        this.$emit("input", name);
      }
    }
  };
};
